import { render, staticRenderFns } from "./TabFixedAttenders.vue?vue&type=template&id=516a5330&scoped=true&"
import script from "./TabFixedAttenders.vue?vue&type=script&lang=js&"
export * from "./TabFixedAttenders.vue?vue&type=script&lang=js&"
import style0 from "./TabFixedAttenders.vue?vue&type=style&index=0&id=516a5330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516a5330",
  null
  
)

export default component.exports